export function doesInclude(list, element) {
  return list.indexOf(element) !== -1;
}
